import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Statistiques d'un profil (vues, favoris, abonnés, messages) + mes actions.
 *  La simple consultation compte une vue côté serveur. */
export const useProfileStats = (profileId, categorie, viewerId) => {
  const [stats, setStats] = useState(null);
  const [chargement, setChargement] = useState(true);
  const [action, setAction] = useState(null);

  const charger = useCallback(async () => {
    if (!profileId || !categorie) return;
    try {
      const r = await axios.get(`${API}/stats/profil/${profileId}`, {
        params: { categorie, viewer_id: viewerId || undefined },
      });
      setStats(r.data);
    } catch {
      setStats(null);
    } finally {
      setChargement(false);
    }
  }, [profileId, categorie, viewerId]);

  useEffect(() => { charger(); }, [charger]);

  /** Bascule une interaction (favori, abonnement, jaime) ou en enregistre une (message). */
  const basculer = useCallback(async (type) => {
    const actif = Boolean(stats?.mes_interactions?.[type]);
    const retirer = type !== "message" && actif;
    setAction(type);
    try {
      const r = await axios.post(`${API}/stats/interaction`, {
        auteur_id: viewerId, cible_id: profileId, categorie, type, retirer,
      });
      setStats((s) => s && {
        ...s,
        interactions: { ...s.interactions, [type]: r.data.compteur ?? s.interactions[type] },
        mes_interactions: { ...s.mes_interactions, [type]: r.data.actif },
      });
      return r.data;
    } finally {
      setAction(null);
    }
  }, [stats, viewerId, profileId, categorie]);

  return { stats, chargement, action, basculer, recharger: charger };
};
